export const version = "logger/5.0.6";
//# sourceMappingURL=_version.js.map